import React, { useEffect, useState } from 'react';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux';
import { fetchReport } from '../../features/planting_calender/plantingReportSlice';
import { startOfWeek, addDays, format } from "date-fns";
import DataTable from 'react-data-table-component';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  title: {
    marginLeft: 10,
  },
});

export default function Calender() {
  const classes = useStyles();
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const report = useSelector((state: any) => state.planting_report.reportData);

    useEffect(() => {
      dispatch(fetchReport({token}))
    }, [dispatch]);

  const runningDatesMap = {}
  const runningDates = []
  let monday = startOfWeek(new Date(), { weekStartsOn: 1})
  for (let i=0; i < 7; i++) {
      let day = addDays(monday,i)
      runningDatesMap[format(day, "yyyy-MM-dd")] = format(day, "ccc")
      runningDates.push(format(day, "yyyy-MM-dd"))
  } 

  const planting = report.data || []
  let tableData = []
  let tableMap = {}

  if (planting.length > 0) {
    tableData = []
    runningDates.forEach((date) => {
      planting.forEach((data) => {

        if (data.PlantDate === date ) {
            let buffer = {}
            buffer["day"] = runningDatesMap[date]
            buffer["name"] = data.Name
            buffer["crop"] = data.Crop
            if (tableMap[runningDatesMap[date]]) {
              let temp = tableMap[runningDatesMap[date]]
              temp.push(buffer)
              tableMap[runningDatesMap[date]] = temp
            } else {
              let temp = []
              temp.push(buffer)
              tableMap[runningDatesMap[date]] = temp
            }

        }
      })
    })
  } 

  const Chips = (props) => {
    let chips = props.chips
    if (Array.isArray(chips)) {
      return props.chips.map((chip) => {
        let text = `${chip.name} ${chip.crop}`
        return (
          <Chip key={text} variant="outlined" label={text}/>
        )
      })
    } else {
      return (<div></div>)
    }
  }

  const Items = () => {
    return runningDates.map((date) => {
      return(
        <div key={date}>
        <Divider component="li" />
        <ListItem>
          <ListItemText primary={runningDatesMap[date]}/>
            <Chips chips={tableMap[runningDatesMap[date]]}/>
        </ListItem>
        <Divider component="li" />
        </div>
        )
    })
  }

  return (
    <React.Fragment>
      <Typography variant="h6" className={classes.title}>
        Planting Calendar this week
      </Typography>
      <List>
        <Items/>
      </List>
    </React.Fragment>
  );
}
